import { AppPhase } from '../../models/communication/app-enums.model';
import { GameChangeEvent } from '../../models/communication/app-state.model';
import { GameBase } from '../game-base';
import { GameFlowBase } from '../game-flow-base';
import { ThreeHeadedDragonCardPosition } from '../main-games/three-headed-dragon/three-headed-dragon.model';
import { CardState } from '../models/game-view.model';

export const threeHeadedDragonStateNames = ['START', 'FACE-UP-CARD', 'CHECK-TIGER', 'SHOW-TIGER', 'OUTCOME'] as const;
export type ThreeHeadedDragonStateName = (typeof threeHeadedDragonStateNames)[number];

export class ThreeHeadedDragonFlow extends GameFlowBase<GameBase, GameChangeEvent, ThreeHeadedDragonStateName> {
    protected override stateNames = threeHeadedDragonStateNames;

    onChange({ action, data }: GameChangeEvent): void {
        switch (this.getState()) {
            case 'START': {
                if (action === 'appPhaseChange' && data === AppPhase.NewRoundPreparation) {
                    this.game.showFaceUpMessage(this.game.getFirstCardPosition());
                    this.nextState();
                }

                break;
            }

            case 'FACE-UP-CARD': {
                if (action === 'tableChange') {
                    this.game.revealCard(data.cardPosition, data.card);

                    if (data.nextCardPosition === ThreeHeadedDragonCardPosition.TigerCard) {
                        this.game.showFaceDownMessage(data.nextCardPosition);
                        this.nextState();
                        return;
                    }

                    if (data.nextCardPosition !== undefined) {
                        this.game.showFaceUpMessage(data.nextCardPosition);
                    }
                }

                break;
            }

            case 'CHECK-TIGER': {
                if (action === 'tableChange') {
                    this.game.updateCard(data.cardPosition, CardState.Checked);
                    this.game.showAllCardsDrawn();
                    this.nextState();
                }

                break;
            }

            case 'SHOW-TIGER': {
                if (action === 'appPhaseChange' && data === AppPhase.Decision) {
                    this.game.showPlayerDecisionTime();
                    return;
                }

                if (action === 'tableChange') {
                    if (data.cardPosition === ThreeHeadedDragonCardPosition.TigerCard) {
                        this.game.revealCard(data.cardPosition, data.card);
                    }

                    if (data.nextCardPosition === undefined) {
                        this.nextState();
                    }
                }

                break;
            }

            case 'OUTCOME': {
                if (action === 'tableChange') {
                    this.game.handleOutcome(data);
                }
            }
        }
    }
}
